import React from 'react';
import Modal from 'react-modal';
import Logger from '../../utils/Logger';
import modal from '../../definitions/Modal';
import { FormattedMessage, injectIntl } from 'react-intl';
import OTButton from '../tag/OTButton';
import OTButtonGroup from '../tag/OTButtonGroup';
import Alert from '../Alert';

const { id: module_id } = module;
const logger = Logger(module_id);

const notificationModal = modal({
  content: { width: '650px', padding: '30px 50px' },
});

const BioBankVersionMismatchModal = ({
  isOpen,
  closeModal,
  latestDocumentVersion,
  status,
}) => {
  return (
    <Modal
      ariaHideApp={false}
      isOpen={isOpen}
      onRequestClose={closeModal}
      style={notificationModal}
    >
      <div className="text-center">
        <div className="row-fluid">
          <p style={{ color: '$darkBlueColor', textAlign: 'left' }}>
            <FormattedMessage
              id={`${module_id}.content`}
              values={{
                version: latestDocumentVersion,
                strong: (chunks) => <strong>{chunks}</strong>,
              }}
            />
          </p>
        </div>
        {status === 'ERROR' && <Alert message={`${module_id}.error`} />}
        <div className="row-fluid">
          <OTButtonGroup
            type={'big'}
            fullWidth
            expectedCount={2}
            collapseOnMobile
          >
            <OTButton
              className="ot-button--gray"
              onClick={() => closeModal('cancel')}
            >
              <FormattedMessage id={'back'} />
            </OTButton>
            <OTButton
              style={{ whiteSpace: 'normal' }} // text is long, so allow wrapping
              disabled={status === 'ERROR'}
              onClick={() => closeModal('next')}
            >
              <FormattedMessage id={`${module_id}.next`} />
            </OTButton>
          </OTButtonGroup>
        </div>
      </div>
    </Modal>
  );
};

export default injectIntl(BioBankVersionMismatchModal);
